import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const ReceiverField = ({ className, name = "receiver_code", label = "Receiver", ...restProps }) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.receiver}
        label={label}
        {...restProps}
    />
);
